import React from "react";
import registerStepIcon from "../../assets/images/register_step.png";
import loginStepIcon from "../../assets/images/login_step.png";
import datasetStepIcon from "../../assets/images/dataset_step.png";
import copyApiStepIcon from "../../assets/images/copy_api_step.png";
import downloadCsvIcon from "../../assets/images/csv_download_step.png";
import useApiStepIcon from "../../assets/images/use_api_step.png";

const Instruction = () => {
    return <>

        <div className={"m-5"} style={{display: 'grid', justifyContent: 'space-evenly'}}>
            <div className="card">
                <div style={{display: 'flex'}}>
                    <img width="50px" src={registerStepIcon} alt="Register"/>
                    <div className="card-header-title pl-4"
                         style={{backgroundColor: "#000", color: "#fff"}}>
                        <b>1. Register</b></div>
                </div>
                <div className="card-content">
                    <h3>Create an account and verify your email to complete the registration process</h3>
                </div>
            </div>

            <div className="card">
                <div style={{display: 'flex'}}>
                    <img width="50px" src={loginStepIcon} alt="Login"/>
                    <div className="card-header-title pl-4"
                         style={{backgroundColor: "#000", color: "#fff"}}>
                        <b>2. Login</b></div>
                </div>
                <div className="card-content">
                    <h3>Enter your registered email and password to access your account</h3>
                </div>
            </div>

            <div className="card">
                <div style={{display: 'flex'}}>
                    <img width="50px" src={datasetStepIcon} alt="Choose Dataset"/>
                    <div className="card-header-title  pl-4"
                         style={{backgroundColor: "#000", color: "#fff"}}>
                        <b>3. Choose Dataset</b></div>
                </div>
                <div className="card-content">
                    <h3>Browse through the available datasets and select the one that fits your needs</h3>
                </div>
            </div>

            <div className="card">
                <div style={{display: 'flex'}}>
                    <img width="50px" src={downloadCsvIcon} alt="Copy API"/>
                    <div className="card-header-title  pl-4"
                         style={{backgroundColor: "#000", color: "#fff"}}>
                        <b>4. Check Preview or CSV</b></div>
                </div>
                <div className="card-content">
                    <h3>Locate the preview or CSV buttons. Try and check the result in csv and json formats respectively.</h3>
                </div>
            </div>
            <div className="card">
                <div style={{display: 'flex'}}>
                    <img width="50px" src={copyApiStepIcon} alt="Copy API"/>
                    <div className="card-header-title  pl-4"
                         style={{backgroundColor: "#000", color: "#fff"}}>
                        <b>5. Copy API</b></div>
                </div>
                <div className="card-content">
                    <h3>Locate the API endpoint associated with your chosen dataset and Copy endpoint URL key and
                        endpoint URL provided</h3>
                </div>
            </div>

            <div className="card">
                <div style={{display: 'flex'}}>
                    <img width="50px" src={useApiStepIcon} alt="Use API"/>
                    <div className="card-header-title  pl-4"
                         style={{backgroundColor: "#000", color: "#fff"}}>
                        <b>6. Use API</b></div>
                </div>
                <div className="card-content">
                    <h3>Integrate the copied endpoint URL into your application or script</h3>
                </div>
            </div>

        </div>

    </>
}

export default Instruction;
